import Raven from 'raven-js';
import { useMemo } from 'react';
// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { useModuleCategories } from '../../../modules/hooks/useModuleCategories';
import ModuleCategoryTypeUrls from '../../../modules/urls/ModuleCategory';
import { deployed } from '../../../utils/env';
import { getFullPublicModulesUrl } from '../../../utils/urls';
import FilterSideNav from './FilterSideNav';
import { jsx as _jsx } from "react/jsx-runtime";
function useModuleCategoryOptions() {
  const moduleCategories = useModuleCategories();
  const options = useMemo(() => {
    return moduleCategories.data.map(({
      displayName,
      name
    }) => ({
      text: displayName,
      value: name
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [moduleCategories]);
  return options;
}
function isModuleCategoryUrlValue(value) {
  return value in ModuleCategoryTypeUrls;
}
function useModuleCategoryNavOptions() {
  const options = useModuleCategoryOptions();
  const isDeployed = deployed();
  return options.reduce((navOptions, option) => {
    const {
      value: optionValue
    } = option;
    if (isModuleCategoryUrlValue(optionValue)) {
      const url = ModuleCategoryTypeUrls[optionValue];
      navOptions.push(Object.assign({}, option, {
        href: `${getFullPublicModulesUrl('en', !isDeployed)}/${url}`
      }));
    } else {
      Raven.captureMessage(`Unknown module category option: ${optionValue}`, {
        level: 'warning',
        extra: {
          option
        }
      });
    }
    return navOptions;
  }, []);
}
function ModuleCategoryNav({
  value
}) {
  const options = useModuleCategoryNavOptions();
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.assets.filters.categories.title'),
    name: "categories",
    options: options,
    value: activeValue
  });
}
export default function ModuleCategoryFilter({
  disabled,
  onChange,
  scrollable = true,
  value
}) {
  const isPrerender = getIsPrerenderUserAgent();
  const options = useModuleCategoryOptions();
  return isPrerender ? /*#__PURE__*/_jsx(ModuleCategoryNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.categories.title'),
    disabled: disabled,
    multi: true,
    name: "categories",
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
}